export default __webpack_public_path__ + "static/media/dreamfest (2).146e3259.jpg";